import styles from './ClassicHome.module.css';

/*
 * The animated pictures of the classic mobile home cards (owner, 2026-10-24).
 * Plain SVG and CSS, coloured with the theme accent, so they stay sharp,
 * light and follow the player's theme.
 */

/** Football into the goal, basketball through the hoop, tennis off the
 *  racket: three seconds each. */
export const SportScene = () => (
  <svg viewBox="0 0 180 124" aria-hidden="true">
    <defs>
      <radialGradient id="hsBallW" cx=".35" cy=".3" r=".75">
        <stop offset="0" stopColor="#fff" />
        <stop offset=".7" stopColor="#e3e8ef" />
        <stop offset="1" stopColor="#9aa4b2" />
      </radialGradient>
      <radialGradient id="hsBallO" cx=".35" cy=".3" r=".8">
        <stop offset="0" stopColor="#ffc07a" />
        <stop offset=".55" stopColor="#f07a1c" />
        <stop offset="1" stopColor="#9c3f08" />
      </radialGradient>
      <radialGradient id="hsBallT" cx=".35" cy=".3" r=".8">
        <stop offset="0" stopColor="#f6ff9a" />
        <stop offset=".6" stopColor="#cde33a" />
        <stop offset="1" stopColor="#7f951a" />
      </radialGradient>
      <linearGradient id="hsPost" x1="0" x2="1">
        <stop offset="0" stopColor="#fff" />
        <stop offset="1" stopColor="#c3cad4" />
      </linearGradient>
      <linearGradient id="hsFrame" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f4f6fa" />
        <stop offset=".5" style={{ stopColor: 'var(--home-acc)' }} />
        <stop offset="1" stopColor="#3a4150" />
      </linearGradient>
      <linearGradient id="hsGlass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffffff40" />
        <stop offset="1" stopColor="#ffffff0a" />
      </linearGradient>
      <pattern id="hsNet" width="6" height="6" patternUnits="userSpaceOnUse">
        <path d="M0 0L6 6M6 0L0 6" stroke="#ffffff55" strokeWidth=".6" />
      </pattern>
      <pattern id="hsStr" width="4" height="4" patternUnits="userSpaceOnUse">
        <path d="M0 0H4M0 0V4" stroke="#ffffffaa" strokeWidth=".5" />
      </pattern>
      <clipPath id="hsHead">
        <ellipse cx="120" cy="50" rx="13" ry="18" />
      </clipPath>
    </defs>

    <g className={`${styles.scene} ${styles.s1}`}>
      <path d="M14 94h152" stroke="#ffffff30" strokeWidth="1" />
      <g className={styles.fbNet}>
        <path d="M66 38h70v54H66z" fill="url(#hsNet)" />
        <path
          d="M54 28l12 10v54M146 28l-10 10v54M66 38h70"
          stroke="#ffffff70"
          strokeWidth="1"
          fill="none"
        />
        <path
          d="M54 28L66 38V92H54zM146 28l-10 10v54h10z"
          fill="url(#hsNet)"
          opacity=".8"
        />
      </g>
      <path
        d="M54 94V28h92v66"
        fill="none"
        stroke="url(#hsPost)"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <ellipse
        className={styles.fbShadow}
        cx="112"
        cy="94"
        rx="9"
        ry="2"
        fill="#0008"
      />
      <g className={styles.fbBall}>
        <circle cx="112" cy="70" r="9" fill="url(#hsBallW)" />
        <path d="M112 64.3l4.4 3.2-1.7 5.2h-5.4l-1.7-5.2z" fill="#1d2330" />
        <path
          d="M103.6 67.5l2.4.7M120.4 67.5l-2.4.7M106.8 77.3l1.6-2.6M117.2 77.3l-1.6-2.6M112 61v3.3"
          stroke="#1d2330"
          strokeWidth="1.6"
        />
      </g>
    </g>

    <g className={`${styles.scene} ${styles.s2}`}>
      <path d="M14 104h152" stroke="#ffffff22" strokeWidth="1" />
      <path d="M150 20v84" stroke="#59606d" strokeWidth="4" />
      <rect
        x="106"
        y="14"
        width="46"
        height="32"
        rx="3"
        fill="url(#hsGlass)"
        stroke="#e9edf3"
        strokeWidth="2.5"
      />
      <rect
        x="121"
        y="26"
        width="16"
        height="12"
        fill="none"
        style={{ stroke: 'var(--home-acc)' }}
        strokeWidth="2"
      />
      <path
        className={styles.bbNet}
        d="M112 52l3 18h14l3-18M112 52l6 6-3 6 4 6M132 52l-6 6 3 6-4 6M118 52l4 6 4-6M115 64h14"
        fill="none"
        stroke="#ffffffb0"
        strokeWidth="1"
      />
      <ellipse
        cx="122"
        cy="52"
        rx="11"
        ry="3"
        fill="none"
        stroke="#ff6a13"
        strokeWidth="3"
      />
      <g className={styles.bbBall}>
        <circle cx="122" cy="44" r="9" fill="url(#hsBallO)" />
        <path d="M113 44h18M122 35v18" stroke="#4a1f05" strokeWidth="1.1" />
        <path
          d="M115.2 37.8c3.8 3.6 3.8 8.8 0 12.4M128.8 37.8c-3.8 3.6-3.8 8.8 0 12.4"
          stroke="#4a1f05"
          strokeWidth="1.1"
          fill="none"
        />
      </g>
    </g>

    <g className={`${styles.scene} ${styles.s3}`}>
      <path d="M14 100h152" stroke="#ffffff40" strokeWidth="1.2" />
      <path
        d="M30 86h120"
        stroke="#ffffff55"
        strokeWidth="1"
        strokeDasharray="2 2"
      />
      <path d="M30 86v14M150 86v14" stroke="#cfd5de" strokeWidth="2" />
      <g className={styles.tnRacket}>
        <ellipse
          cx="120"
          cy="50"
          rx="13"
          ry="18"
          fill="url(#hsStr)"
          clipPath="url(#hsHead)"
        />
        <ellipse
          cx="120"
          cy="50"
          rx="14"
          ry="19"
          fill="none"
          stroke="url(#hsFrame)"
          strokeWidth="4"
        />
        <path
          d="M114 67l6 10 6-10"
          fill="none"
          stroke="url(#hsFrame)"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        <rect
          x="117.5"
          y="76"
          width="5"
          height="22"
          rx="2"
          fill="#1d222c"
          stroke="#ffffff30"
        />
        <path
          d="M117.5 80l5 2M117.5 85l5 2M117.5 90l5 2"
          stroke="#ffffff40"
          strokeWidth="1"
        />
      </g>
      <g className={styles.tnBall}>
        <circle cx="100" cy="50" r="6" fill="url(#hsBallT)" />
        <path
          d="M95 47.5c3 2.2 7 2.2 10 0M95 52.5c3-2.2 7-2.2 10 0"
          stroke="#fffde8"
          strokeWidth="1"
          fill="none"
        />
      </g>
    </g>
  </svg>
);

/** A scoreboard that turns 1:0 into 1:1, with a live dot. */
export const LiveScene = () => (
  <>
    <div className={styles.liveDot}>
      <i />
      LIVE
    </div>
    <div className={styles.board}>
      <span className={styles.shirt} />
      <span className={styles.score}>
        <span>1:0</span>
        <span>1:1</span>
      </span>
      <span className={`${styles.shirt} ${styles.shirtAway}`} />
    </div>
    <div className={styles.goal}>GOOOL!</div>
    <div className={styles.minute}>67'</div>
  </>
);

const REEL = ['7', '★', '♦', 'B', '♣', '★', '♦', '♣', 'B'];

/** Three reels that spin and stop on 7 7 7. */
export const SlotScene = () => (
  <>
    <div className={styles.reels}>
      {[0, 1, 2].map((r) => (
        <div className={styles.reel} key={r}>
          <div className={styles.strip}>
            {[...REEL.slice(r), ...REEL.slice(0, r)].map((x, i) => (
              <b key={i}>{x}</b>
            ))}
            <b className={styles.seven}>7</b>
          </div>
        </div>
      ))}
    </div>
    <div className={styles.win}>JACKPOT</div>
  </>
);

/** A roulette wheel with the ball running the other way. */
export const RouletteScene = () => (
  <>
    <div className={styles.wheel} />
    <div className={styles.orbit}>
      <i />
    </div>
    <div className={styles.chips}>
      <i />
      <i />
      <i />
    </div>
  </>
);

const DRAWN: [number, string][] = [
  [7, '#e53935'],
  [18, '#43a047'],
  [23, '#1e88e5'],
  [31, '#8e24aa'],
  [40, '#f4511e'],
  [46, '#6d4c41'],
];

const ballGrad = (id: string, light: string, dark: string) => (
  <radialGradient id={id} cx=".35" cy=".3" r=".8">
    <stop offset="0" stopColor={light} />
    <stop offset="1" stopColor={dark} />
  </radialGradient>
);

/** A glass drum tumbling the balls, and six drawn balls dropping out. */
export const LuckySixScene = () => (
  <>
    <svg className={styles.drum} viewBox="0 0 120 80" aria-hidden="true">
      <defs>
        <radialGradient id="hsSph" cx=".38" cy=".3" r=".8">
          <stop offset="0" stopColor="#ffffff38" />
          <stop offset=".55" stopColor="#ffffff0c" />
          <stop offset="1" stopColor="#00000055" />
        </radialGradient>
        <linearGradient id="hsMetal" x1="0" x2="1">
          <stop offset="0" stopColor="#5b6170" />
          <stop offset=".45" stopColor="#e9edf3" />
          <stop offset="1" stopColor="#4a505c" />
        </linearGradient>
        {ballGrad('hsB1', '#ff8a80', '#b71c1c')}
        {ballGrad('hsB2', '#a5d6a7', '#1b5e20')}
        {ballGrad('hsB3', '#90caf9', '#0d47a1')}
        {ballGrad('hsB4', '#e1bee7', '#4a148c')}
        {ballGrad('hsB5', '#fff59d', '#f57f17')}
        <clipPath id="hsSphClip">
          <circle cx="60" cy="34" r="27" />
        </clipPath>
      </defs>
      <path d="M44 62h32l6 14H38z" fill="url(#hsMetal)" />
      <rect x="34" y="74" width="52" height="4" rx="2" fill="url(#hsMetal)" />
      <path
        d="M86 46c10 2 14 10 14 24"
        fill="none"
        stroke="url(#hsMetal)"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle
        cx="60"
        cy="34"
        r="29"
        fill="none"
        stroke="url(#hsMetal)"
        strokeWidth="3"
      />
      <circle cx="60" cy="34" r="27" fill="#05070bcc" />
      <g clipPath="url(#hsSphClip)">
        <g className={styles.tumble}>
          <circle cx="48" cy="26" r="6" fill="url(#hsB1)" />
          <circle cx="66" cy="20" r="6" fill="url(#hsB2)" />
          <circle cx="72" cy="38" r="6" fill="url(#hsB3)" />
          <circle cx="52" cy="44" r="6" fill="url(#hsB4)" />
          <circle cx="61" cy="33" r="6" fill="url(#hsB5)" />
          <circle cx="40" cy="36" r="6" fill="url(#hsB3)" />
          <circle cx="76" cy="26" r="6" fill="url(#hsB1)" />
          <circle cx="62" cy="50" r="6" fill="url(#hsB2)" />
        </g>
      </g>
      <circle
        cx="60"
        cy="34"
        r="27"
        fill="url(#hsSph)"
        style={{ stroke: 'var(--home-acc)' }}
        strokeOpacity=".6"
        strokeWidth="1.2"
      />
      <ellipse
        cx="50"
        cy="20"
        rx="10"
        ry="5"
        fill="#ffffff30"
        transform="rotate(-25 50 20)"
      />
    </svg>
    <div className={styles.drawn}>
      {DRAWN.map(([n, c]) => (
        <b key={n} style={{ backgroundColor: c }}>
          {n}
        </b>
      ))}
    </div>
  </>
);

// Keno: a board of twenty numbers in the game's colours (1-20 green, 21-40
// blue, 41-60 orange, 61-80 yellow) that light up one by one as they are
// drawn, and the round multiplier.
const KENO_BOARD = [3, 9, 14, 18, 22, 27, 31, 38, 42, 47, 53, 58, 61, 66, 77];
const KENO_LIT = [9, 27, 42, 66, 18, 53, 31, 77];
const kenoColor = (n: number) =>
  ['#5fb648', '#3d95e6', '#ee7a2c', '#f2cc43'][Math.floor((n - 1) / 20)];

/** A keno board lighting up its drawn numbers, and the round multiplier. */
export const KenoScene = () => (
  <>
    <div className={styles.kenoBoard}>
      {KENO_BOARD.map((n) => {
        const lit = KENO_LIT.indexOf(n);
        return (
          <b
            key={n}
            className={lit >= 0 ? styles.kenoLit : undefined}
            style={
              {
                '--c': kenoColor(n),
                animationDelay: lit >= 0 ? `${lit * 0.55}s` : undefined,
              } as React.CSSProperties
            }
          >
            {n}
          </b>
        );
      })}
    </div>
    <span className={styles.kenoMult}>×2</span>
  </>
);

/** A flickering flame with sparks. */
export const FlameScene = () => (
  <>
    <svg className={styles.flame} viewBox="0 0 64 80" aria-hidden="true">
      <defs>
        <linearGradient id="hsFl" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#fff3c4" />
          <stop offset=".35" stopColor="#ffb02e" />
          <stop offset="1" stopColor="#ff4d2e" />
        </linearGradient>
      </defs>
      <path
        d="M32 2C36 18 54 26 54 48a22 22 0 0 1-44 0c0-10 6-16 10-22 2 8 6 10 8 10-2-12 2-24 4-34z"
        fill="url(#hsFl)"
      />
      <path
        d="M32 40c4 6 10 9 10 17a10 10 0 0 1-20 0c0-5 4-8 6-12 1 3 3 4 4 4-1-3 0-6 0-9z"
        fill="#fff6d6"
      />
    </svg>
    <i className={styles.spark} style={{ left: '44%' }} />
    <i
      className={styles.spark}
      style={{ left: '58%', animationDelay: '.8s' }}
    />
    <i
      className={styles.spark}
      style={{ left: '50%', animationDelay: '1.6s' }}
    />
  </>
);
